export default "__VITE_ASSET__6ney8yO9__"